/* eslint-disable @typescript-eslint/restrict-template-expressions */
/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2021, Zumper
 */

import { Theme, css } from '@emotion/react'
import { ALPHA_48, BREAKPOINT_MOBILE, Z_INDEX_MODAL_BACKDROP, focusRing } from '@zcode-ui/themes'

export const overlay = css`
  background-color: ${`#000000${ALPHA_48}`};
  z-index: ${Z_INDEX_MODAL_BACKDROP};
`

export const content = ({ colors, spacing }: Theme) => css`
  height: max-content;
  background-color: ${colors.backgroundLight};
  border-radius: ${spacing.spacing3};
`

export const closeButton = ({ colors, spacing, typography }: Theme) => css`
  position: absolute;
  top: 28px;
  right: 28px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 20px;
  height: 20px;

  background: transparent;
  border: 0;
  border-radius: ${spacing.spacing2};
  padding: 0;

  cursor: pointer;

  transition: background 150ms ease-in, box-shadow 150ms ease-in;

  &:hover {
    background-color: ${colors.background};
  }

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:focus-visible {
    ${focusRing({ colors, spacing, typography })}
  }

  svg {
    width: 8px;
    height: 8px;
  }

  @media (max-width: ${BREAKPOINT_MOBILE}) {
    top: 1px;
    right: 1px;
    width: 44px; // minimum tap size for mobile
    height: 44px;
    border-radius: 50%;

    svg {
      padding: 5px;
      border-radius: 3px;
      width: 18px;
      height: 18px;
    }

  }
`

export const body = ({ spacing, typography }: Theme) => css`
  padding: ${spacing.spacing8} ${spacing.spacing6} ${spacing.spacing5};

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${typography.fontWeightMedium};
    font-family: var(--chakra-fonts-heading);
  }
`

export const footer = ({ colors, spacing }: Theme) => css`
  justify-content: flex-start;
  padding: ${spacing.spacing5} ${spacing.spacing6};

  border-top: solid 1px ${colors.background};
`
